import GatewayDetailsContainer from './containers/GatewayDetailsContainer'

// Sync route definition
export default {
  path: '/system/:gatewayId',
  component : GatewayDetailsContainer,
}
